<body class="">
    <div class="failedhead ">
        <div class="container-fluid d-flex h-100 align-items-center" >
          <div class="mx-auto col-12 text-center">
            <h1 style="font-size: 20px;"class="mx-auto mt-2 text-uppercase"><mark class="mx-auto my-0 text-uppercase" style="background-color:black; opacity:1;letter-spacing:2px;">OUPS....</mark></h1>
            <h2 style="color: black;font-size: 18px;" class=" mx-auto mt-2 text-uppercase">We are currently in maintenance. Thank you for visiting us. See you soon.</h2>
          </div>
        </div>
      </div>
</body>